module.exports = __webpack_public_path__ + "840362e361507db1dc4f8571324ac93b.png";